import React, { FC, useCallback, useState } from 'react';
import {
  FormItemBeneficialOwnerDetailList,
  DataSourceTag,
  FormModule,
  BeneficialPenetrationModal,
} from '@purchase/supplier';
import type {
  BreakThroughInfoDto,
  VendorQccBeneficialOwnerInfoDto,
} from '@purchase/supplier';
import { useExecutiveRelationModal } from '../../Qcc/useExecutiveRelationModal';
import { ProForm } from '@bedrock/eed-react';

const BeneficialOwnerModule: FC<{
  formDetail: any;
  isExternal: boolean;
}> = ({ formDetail, isExternal }) => {
  const wrapper: VendorQccBeneficialOwnerInfoDto | undefined =
    formDetail?.vendorQccBeneficialOwnerInfo;
  const findMatched = wrapper?.findMatched === 'Y';
  const list = findMatched
    ? (wrapper?.vendorQccBeneficialBreakThroughInfos ?? [])
    : [];
  const updateTime = formDetail?.qccDataFetchedAt;
  const count = list.length;

  const { openModal, modalElement, hasRelationData } =
    useExecutiveRelationModal(formDetail);

  const [penetration, setPenetration] = useState<{
    open: boolean;
    record?: BreakThroughInfoDto;
  }>({ open: false });

  const handleViewPenetration = useCallback((record: BreakThroughInfoDto) => {
    setPenetration({ open: true, record });
  }, []);

  const handleClosePenetration = useCallback(() => {
    setPenetration((s) => ({ ...s, open: false }));
  }, []);

  if (isExternal) return null;

  return (
    <>
      <FormModule
        title="受益所有人"
        titleCount={count}
        proCardProps={{
          expandable: true,
          defaultExpanded: count > 0,
          rightSlot: <DataSourceTag source="企查查" updateTime={updateTime} />,
        }}
      >
        <ProForm.Descriptions>
          <ProForm.Descriptions.Item label="直接/间接控股的企业受益股东">
            {findMatched ? '存在' : '不存在'}
          </ProForm.Descriptions.Item>
        </ProForm.Descriptions>

        {findMatched && (
          <FormItemBeneficialOwnerDetailList
            className="mt-3"
            name={[
              'vendorQccBeneficialOwnerInfo',
              'vendorQccBeneficialBreakThroughInfos',
            ]}
            onPersonClick={openModal}
            isPersonClickable={hasRelationData}
            onViewShareholdingPenetration={handleViewPenetration}
          />
        )}
      </FormModule>
      {modalElement}
      <BeneficialPenetrationModal
        open={penetration.open}
        onClose={handleClosePenetration}
        record={penetration.record}
        wrapper={wrapper}
      />
    </>
  );
};

export default BeneficialOwnerModule;
